export class LiveConnectResponse {
    Server: string;
    Port: number;
    UseSsl: boolean;
    VirtualHost: string;
    Username: string;
    Password: string;
    QueueName: string;
    ExchangeName: string;
}